// Scale factor: pixels per meter
// Default: 118 pixels = 1 meter
export const SCALE_FACTOR = 118.0;

// Standard vertical drop per circuit in meters
// Default: 8 meters (floor to ceiling)
export const VERTICAL_DROP_PER_CIRCUIT = 8.0;
